import level1Activities from "./level1Activities";
import level1Catalog from "./level1Catalog";
import { costCategories, costItemNotes, costItems } from "./level1Costs";

export default {
  // Intro screen
  introTitle: "Conte-nos mais sobre seu projeto",
  introSubtitle: "Preencha o formulário para configurar seu projeto de carbono",
  startApplication: "Iniciar inscrição",
  introSummary: "Resumo",
  introSummaryDesc: "Informações gerais do projeto",
  introData: "Dados",
  introDataDesc: "Arquivos de limite, PDD e dados de campo",
  introCredits: "Créditos",
  introCreditsDesc: "Projeções de créditos de carbono",
  introCosts: "Custos",
  introCostsDesc: "Custos ao longo da vida do projeto",

  // Navigation
  learnMore: "Saiba mais",
  previous: "Anterior",
  continue: "Continuar",
  submit: "Enviar",
  backToDrafts: "Voltar aos rascunhos",
  submissionFailed:
    "Não foi possível enviar o projeto. Seu rascunho continua salvo. Tente novamente ou fale com o suporte se o problema continuar.",
  auditorNotApproved:
    "O auditor selecionado não está aprovado no registro de confiança ativo em blockchain. Um administrador deve aprovar o auditor na página de administração antes do envio do projeto.",
  submissionSupportReference: "Referência de suporte: {reference}",
  contactSupport: "Falar com o suporte",
  stagePricingFailed:
    "Não foi possível calcular o preço por etapa. Tente novamente.",
  editCosts: "Editar custos",

  // Step 1: Summary
  projectName: "Nome do projeto",
  projectNamePlaceholder: "Nome do projeto",
  projectDescription: "Descrição do projeto",
  projectDescriptionPlaceholder:
    "Uma visão geral abrangente da área, objetivos etc.",
  projectType: "Tipo de projeto",

  // Step 2: Data
  projectBoundary: "Limite do projeto",
  projectBoundaryDesc: "Limite geográfico da área do seu projeto",
  uploadKmlFile: "Enviar arquivo KML",
  uploadKmlKmz: "Enviar KML/KMZ",
  uploading: "Enviando...",
  uploadError: "Falha no envio. Tente novamente.",
  calculatingCarbonEstimate: "Calculando estimativa de carbono…",
  computingCredits: "Calculando créditos de carbono...",
  fieldData: "Dados de campo",
  fieldDataDesc: "Medições de parcelas e dados de validação em campo",
  existingDataset: "Conjunto de dados existente",
  uploadDataset: "enviar conjunto de dados",
  noDataset: "Sem conjunto de dados",
  useRemoteSensing: "Usar sensoriamento remoto",
  certification: "Certificação",
  methodology: "Metodologia",
  pddInfo:
    "Um Documento de Concepção do Projeto (PDD) deverá ser criado ou enviado conforme a metodologia selecionada.",
  landOwnershipStatus: "Status de propriedade da terra",
  landOwnershipPlaceholder: "Selecione o tipo de posse",
  landOwnershipHelper:
    "Campo derivado das convenções brasileiras de posse da terra (CCIR/matrícula, posse, assentamento, terra indígena, quilombola, UC, concessão).",
  landStatusOptions: {
    private_title: "Privada",
    possession: "Posse (informal)",
    agrarian_settlement: "Assentamento de reforma agrária",
    indigenous_territory: "Terra indígena",
    quilombola: "Comunidade quilombola",
    conservation_unit: "Unidade de conservação (RPPN, APA, ...)",
    forest_concession: "Concessão florestal",
    other: "Outro (especificar)",
  },
  // Step 3: Credits
  estimationMethod: "Método de estimativa",
  fieldPlotData: "Dados de parcelas de campo",
  biomassCalculator: "Calculadora de biomassa",
  plotBasedEstimation: "Estimativa baseada em parcelas",
  remoteSensingEstimation: "Estimativa por sensoriamento remoto",
  plotsAnalyzed: "{count} parcelas analisadas em {area} hectares",
  projected: "Projetado",
  lowEstimate: "Estimativa baixa",
  midEstimate: "Estimativa média",
  highEstimate: "Estimativa alta",
  years: "{n} anos",
  creditsNotReady: "Volte à etapa Dados para enviar o arquivo KML/KMZ e o conjunto de dados antes de ver as estimativas de crédito.",
  creditsComputing: "Calculando estimativas de crédito. Aguarde antes de continuar.",
  creditsComputeFailed:
    "Não foi possível calcular as estimativas de crédito. O servidor não retornou uma resposta utilizável. Tente novamente ou fale com o suporte se continuar.",
  creditsComputeFailedWithDetail: "Não foi possível calcular as estimativas de crédito: {error}",
  yearsProjected: "{count} anos projetados",

  // Step 4: Costs
  costSetting: "Configuração de custos",
  costSettingDesc: "Configuração-base para os cálculos de custo",
  currency: "Moeda",
  startYear: "Ano inicial",
  durationYears: "Duração (anos)",
  durationYearsValue: "{years} anos",
  timelineMirror: "(definido na aba Cronograma)",
  perYearBreakdownTitle: "Detalhamento de custos por ano",
  perYearBreakdownDesc:
    "Apenas sugestão — derivado do cronograma. Os totais editáveis acima continuam sendo a fonte de verdade.",
  year: "Ano",
  totalLabel: "Total geral",
  cost: {
    validation: "Validação",
    monitoring: "Monitoramento",
    verification: "Verificação",
    issuance: "Emissão",
    community: "Comunidade",
  },
  otherCertifierFeesTitle: "Outras taxas do certificador",
  otherCertifierFeesDesc:
    "Taxas transacionais e metodológicas do certificador, ortogonais ao ciclo do projeto. Mostradas para visibilidade; não somadas ao total de custos.",
  requiresQuoteTitle: "Requer cotação",
  landownerCompensation: {
    title: "Compensação ao proprietário",
    desc: "Compensação opcional financiada pelo investidor para projetos em terra privada antes dos créditos serem comercializáveis.",
    include: "Incluir custo de compensação",
    total: "Total",
    monthly: "Mensal",
    monthlyPerFamily: "Mensal por família",
    estimatedFamilies: "Estimativa de famílias beneficiárias",
    estimatedFamiliesInvalid: "Informe um número inteiro maior que zero.",
    months: "Meses",
    stageCostIncluded: "Distribuído entre os custos das etapas aplicáveis do projeto.",
    allocation: "Alocação",
    payoutStart: "Início do pagamento",
    startStage: "Iniciar após etapa",
    startDate: "Data de início",
    maxMonths: "Meses máximos",
    removedReason: "Motivo da remoção",
    removedReasonPlaceholder: "Motivo para remover este custo",
    payoutProjectStart: "Início do projeto",
    payoutAfterStage: "Após a etapa selecionada ser financiada",
    payoutExplicitDate: "Data explícita",
    allocationUniform: "Distribuída entre etapas",
    allocationUpfront: "Escrow antecipado",
    basis: "Base",
    winningComponent: "Componente vencedor",
    confidence: "Confiança",
    estimateOnly: "Apenas estimativa",
    productionBlocked: "Ainda não utilizável em produção",
  },
  communityBenefitPayout: {
    title: "Pagamento de benefício comunitário",
    desc: "Pagamento opcional financiado pelo investidor para projetos elegíveis de REDD+ e conservação.",
    include: "Incluir benefício comunitário",
    total: "Total",
    monthly: "Mensal",
    monthlyPerFamily: "Mensal por família",
    monthlyPayoutPerFamily: "Pagamento mensal por família (R$)",
    monthlyPayoutPerFamilyInvalid: "Informe um valor mensal maior que zero.",
    amountInvalid: "Informe um valor maior que zero.",
    estimatedFamilies: "Estimativa de famílias beneficiárias",
    estimatedFamiliesInvalid: "Informe um número inteiro positivo de famílias.",
    months: "Meses",
    allocation: "Alocação",
    payoutStart: "Início do pagamento",
    startStage: "Iniciar após etapa",
    startDate: "Data de início",
    maxMonths: "Meses máximos",
    removedReason: "Motivo da remoção",
    removedReasonPlaceholder: "Motivo para remover este pagamento",
    payoutProjectStart: "Início do projeto",
    payoutAfterStage: "Após a etapa selecionada ser financiada",
    payoutExplicitDate: "Data explícita",
    allocationUniform: "Distribuída entre etapas",
    allocationUpfront: "Escrow antecipado",
    stageCostIncluded: "Distribuído entre os custos das etapas aplicáveis do projeto.",
    basis: "Base",
    winningComponent: "Componente vencedor",
    confidence: "Confiança",
    estimateOnly: "Apenas estimativa",
    productionBlocked: "Ainda não utilizável em produção",
    notCalculable: "Não calculável com as fontes, créditos e beneficiários atuais.",
    notCalculableAction: "Complete o acordo de repartição de benefícios e a estimativa de famílias beneficiárias para calcular este pagamento.",
    missingInputs: "Entradas necessárias",
    predictionLadder: "Caminhos de cálculo",
    estimateTag: "Estimativa",
    estimateRung: "Etapa do cálculo",
    revenueBasis: "Base de receita",
    sources: "Fontes",
    beneficiaries: "Beneficiários",
    perHousehold: "Por família",
    perHouseholdMonthly: "Por família por mês",
    ladder: {
      sourced_minimum: "Acordo assinado ou mínimo legal/normativo com fonte.",
      pct_of_forecast_revenue: "Créditos previstos no período, preço selecionado e percentual com fonte.",
      opportunity_cost_floor: "Área comunitária elegível e piso de custo de oportunidade atribuído à comunidade.",
      unavailable: "É necessário um acordo assinado quando nenhum caminho de previsão é utilizável.",
    },
    yes: "Sim",
    audit: {
      platform_policy_proxy: "Proxy de política da plataforma",
      pct_of_forecast_revenue: "Percentual da receita de carbono prevista",
      proxy_per_hectare: "Política proxy por hectare",
      proxy_per_household: "Política proxy por família",
      unavailable: "Indisponível",
      platform_policy_proxy_estimate_only:
        "Esta é apenas uma estimativa proxy da política da plataforma.",
      area_overlap_unchecked:
        "A revisão de sobreposição de área ainda não foi feita; o uso em produção está bloqueado.",
      benefit_share_reference_unverified:
        "A referência de repartição de benefícios encontrada ainda não está verificada para este padrão.",
      benefit_share_reference_requires_approval:
        "A referência de repartição de benefícios exige aprovação jurídica/administrativa.",
      community_benefit_proxy_policy_missing:
        "Não há política proxy ativa de benefício comunitário.",
      community_benefit_proxy_policy_has_no_computable_rate:
        "A política proxy ativa não tem taxa calculável para este rascunho.",
      community_benefit_proxy_policy_missing_provenance:
        "A política proxy não tem aprovação ou proveniência de fonte.",
      community_benefit_source_provenance_missing:
        "O valor de benefício informado por fonte não tem proveniência suficiente.",
      community_benefit_fixture_value_rejected:
        "Um valor de benefício com aparência de dado de teste foi rejeitado.",
      community_benefit_estimate_unavailable:
        "A estimativa de benefício comunitário não é calculável com os dados atuais.",
      forecast_revenue_missing:
        "Faltam créditos previstos ou preço selecionado.",
      community_benefit_forecast_revenue_missing:
        "Faltam créditos previstos ou preço selecionado.",
      community_benefit_forecast_credit_estimate_refused:
        "A estimativa atual de créditos de carbono foi recusada e não pode fundamentar o benefício.",
      community_benefit_forecast_credit_estimate_missing:
        "É necessária uma estimativa atual de créditos de carbono.",
      forecast_credit_estimate_refused:
        "A estimativa atual de créditos de carbono foi recusada.",
      benefit_compensation_overlap_review:
        "A sobreposição entre compensação ao proprietário e benefício comunitário exige revisão antes da alocação.",
      signed_benefit_sharing_agreement_required:
        "É necessário um acordo assinado de repartição de benefícios para este contexto.",
      outside_commercial_driver_requires_agreement:
        "Projetos com agente comercial externo exigem acordo assinado de repartição de benefícios.",
      benefit_share_revenue_basis_requires_review:
        "A base de receita encontrada exige revisão jurídica/administrativa antes do uso.",
      estimate_only_prediction:
        "Esta estimativa é apenas para investimento e não pode ser usada em produção.",
      no_beneficiary_identified:
        "Os beneficiários ainda não foram identificados.",
      beneficiary_kyc_not_verified_for_direct_payout:
        "O KYC do beneficiário não está verificado para pagamento direto.",
      safeguards_failed_or_missing:
        "As evidências de salvaguardas estão ausentes ou não aprovadas.",
      proxy_fixed_minimum_floor_applied:
        "O mínimo fixo da plataforma elevou a estimativa calculada.",
      low: "Baixa",
      medium: "Média",
      high: "Alta",
      blocked: "Bloqueada",
    },
  },
  scaleClassification: "Classificação de escala (FR.CER.001)",
  scaleClassificationDesc: "Calculada automaticamente a partir dos créditos",
  estimatedTco2eYear: "tCO2e/ano estimado",
  projectScale: "Escala do projeto",
  smallScale: "Pequena (menos de 16.000 tCO2e/ano)",
  largeScale: "Grande (>= 16.000 tCO2e/ano)",
  loadingCostEstimates: "Carregando estimativas de custo...",
  validationVvb: "Validação / Arranjo de VVB",
  vvbBasedOn: "Baseado em DC.GOV.002 e DC.GOV.003",
  vvbSmallScaleTitle: "Pequena escala — a Tero contrata o auditor",
  vvbSmallScaleCost: "Custo de validação: {cost} (fixo)",
  teroSmallScaleFeeText:
    "convertido para R$ nesta estimativa (taxa de origem USD 1.000/projeto; critérios de aceite USD 1.000 + USD 200/propriedade rural)",
  vvbSmallScaleDesc:
    "Para projetos de pequena escala, a Tero Carbon contrata o VVB diretamente para garantir conformidade com regras de conflito de interesse. O custo de validação é fixado pela taxa padrão da Tero.",
  oneTime: "Pontual",
  recurring: "Recorrente",
  addItem: "adicionar item",
  itemName: "Nome do item",
  amount: "Valor",
  units: {
    credit: "crédito",
    year: "ano",
  },
  costSummary: "Resumo de custos",
  year1Total: "Total do ano 1",
  avgAnnual: "Média anual",
  lifetimeTotal: "Total do período",
  costPerCredit: "Custo / crédito",
  costBreakdown: "Detalhamento de custos",

  // Step 5: Price Quote
  priceQuoteTitle: "Cotação de preço",
  priceQuoteDesc: "Selecione a estratégia vendável que deseja aplicar. Pisos diagnósticos aparecem separadamente.",
  recompute: "Recalcular",
  loadingQuote: "Calculando cotação de preço...",
  priceQuoteFailed: "Falha ao calcular a cotação. Entre novamente ou tente recalcular antes de continuar.",
  loadingStagePricing: "Calculando preços por etapa...",
  indicativePrice: "Preço indicativo",
  bandFloor: "Mínimo",
  bandSuggested: "Sugerido",
  bandStretch: "Estendido",
  bandCeiling: "Máximo",
  priceOptionRecommended: "Preço viável recomendado para o contrato",
  priceOptionFeasible: "Preço viável para o contrato",
  priceOptionTiers: {
    floor: "Mínimo",
    suggested: "Sugerido",
    stretch: "Estendido",
    ceiling: "Máximo",
  },
  roiOnCashCosts: "Retorno sobre custos de caixa",
  breakEvenFloorLabel: "Piso de equilíbrio",
  breakEvenDiagnostic:
    "{price} de equilíbrio econômico com custo de oportunidade. O preço sugerido fica {margin} acima desse piso. Não vendável.",
  singleFeasiblePriceAlgorithm:
    "Apenas um algoritmo de preço produziu um valor viável para o contrato. Os demais resultados aparecem abaixo para comparação.",
  algorithmFeasibleDiagnostic:
    "{price} é o resultado viável deste algoritmo para o contrato. Selecione acima uma das opções verificadas da faixa de preço para continuar.",
  algorithmBelowFeasibleFloor:
    "Este algoritmo alcança {maximum}, abaixo do mínimo de {minimum} exigido pelo financiamento das etapas e pelo limite de alocação ao investidor. Não pode ser selecionado.",
  priceStrategies: {
    supply_curve_oc: "Curva de oferta + custo de oportunidade",
    lcor: "Custo nivelado de restauração",
    lcos: "Custo nivelado de sequestro",
    macc_breakeven: "MACC / preço de equilíbrio",
    label_multiplier: "Multiplicador por selo",
    leaf_art_floor: "Piso LEAF/ART",
    frontier_pathway_comp: "Comparação com trajetória Frontier",
    sovcm_median: "Mediana do Ecosystem Marketplace",
    forward_shadow_price: "Preço-sombra futuro",
  },
  priceStrategyNotes: {
    supply_curve_oc: "Piso da curva de oferta para {projectClass}",
    leaf_art_floor: "Piso jurisdicional publicado pela LEAF/ART",
    sovcm_median: "Mediana SOVCM 2025 da categoria (lado da demanda)",
    forward_shadow_price: "REMIND-MAgPIE, US$ 2010, economias avançadas",
    verra_nature_qha: "Verra Nature Framework Qha (não tCO2e - unidade separada)",
    frontier_pathway_comp: "Média da trajetória Frontier para {pathway}",
    lcor: "LCOR: {technique} em {biome}",
    peatland_lcor: "LCOR de emissões evitadas em turfeiras [{variant}]",
    lcos: "LCOS {subclass} [{variant}]",
    macc_breakeven: "MACC {projectClass} [{subType}]",
    label_multiplier: "Multiplicador por selo sobre a base tCO2e (+{premium})",
  },
  priceStrategyDiagnostics: {
    supply_curve_oc:
      "{price} é o resultado da curva de oferta com base nos custos salvos e no custo de oportunidade do uso da terra deslocado. Não é um preço de venda viável para este rascunho.",
    lcor:
      "{price} é o resultado do custo nivelado de restauração. Não é um preço de venda viável para este rascunho.",
    lcos:
      "{price} é o resultado do custo nivelado de sequestro. Não é um preço de venda viável para este rascunho.",
    macc_breakeven:
      "{price} é o resultado do custo marginal de abatimento. Não é um preço de venda viável para este rascunho.",
    default:
      "{price} é o resultado calculado por este algoritmo. Não é um preço de venda viável para este rascunho.",
  },
  priceStrategyRoleLabels: {
    break_even_floor: "Piso de equilíbrio",
    binding_break_even_floor: "Piso vinculante",
    market_anchored_price: "Preço vendável",
    market_reference_below_cost_floor: "Abaixo do piso de custo",
    reference_price: "Apenas referência",
    sellable_price: "Preço vendável",
    contract_infeasible_price: "Não selecionável",
    algorithm_low_price: "Preço viável do algoritmo",
    algorithm_mid_price: "Preço viável do algoritmo",
    algorithm_high_price: "Preço viável do algoritmo",
  },
  priceProjectClasses: {
    aud_redd_plus: "desmatamento evitado / REDD+",
    apd: "desmatamento planejado evitado",
    acogs: "conversão evitada de ecossistemas",
    ifm: "manejo florestal melhorado",
    arr: "restauração ARR",
    blue_carbon: "carbono azul",
    peatland: "turfeiras",
    grasslands: "pastagens",
    smallholder_agroforestry: "agrofloresta de pequenos produtores",
    native_veg_brazil: "restauração de vegetação nativa no Brasil",
    alm_soc: "manejo agrícola / carbono do solo",
    urban_forestry: "florestas urbanas",
    biodiversity_wrapper: "camada de biodiversidade",
    engineered_removal: "remoção tecnológica de carbono",
    methane_waste: "metano de resíduos",
    community_development: "desenvolvimento comunitário",
    energy_industry: "energia e indústria",
  },

  // Stage pricing block
  stagePricingTitle: "Preço por etapa",
  stagePricingDesc: "Preço e ROI por etapa para cada ano do período de crédito. Clique em um ano para expandir.",
  stagePricingNoData: "Ainda não há dados de preço por etapa. Complete a etapa Preço e continue para ver os resultados aqui.",
  stagePricingNoStageDetail: "Nenhum detalhe de etapa disponível.",
  yearLabel: "Ano {n}",
  showMoreYears: "+ Mostrar mais {count} ano | + Mostrar mais {count} anos",
  showFewerYears: "Mostrar menos anos",
  avgRoi: "ROI",

  // Step 6: Review
  reviewTitle: "Revisão",
  missingPdd: "PDD ausente",
  missingPddDesc:
    "Um PDD é obrigatório antes de enviar seu projeto.",
  createPdd: "Criar PDD",
  upload: "Enviar",
  uploadPdd: "Anexar",
  replacePdd: "Substituir PDD",
  pddUploaded: "PDD anexado",
  pddUploadedDesc: "O arquivo PDD está anexado.",
  location: "Localização",
  projectArea: "Área do projeto",
  projectAreaValue: "{area} ha",
  totalCredits: "Créditos totais",
  peakYear: "Ano de pico ({year})",
  estimationMethodLabel: "Método de estimativa",
  lifetimeTotalCosts: "Custos totais do período",
  annualAverage: "Média anual",
  costPerCreditLabel: "Custo por crédito",

  // Revenue block
  lifetimeTotalRevenue: "Receita total do período",
  year1Revenue: "Receita do ano 1",
  avgRevenue: "Receita média",

  // Profit block
  lifetimeProfit: "Lucro do período",
  year1Profit: "Lucro do primeiro ano de emissão",
  annualAverageRoi: "ROI médio anual",
  profitPerCredit: "Lucro por crédito",

  mapNotAvailable: "Pré-visualização do mapa indisponível. Envie um arquivo KML/KMZ para ver a área do projeto.",

  // Step 3: Activities
  activitiesTitle: "Selecionar atividades",
  activitiesDesc: "Escolha as atividades que se aplicam ao seu projeto",
  addOwnEntry: "Adicionar sua própria entrada",
  customActivity: "Atividade personalizada",
  activityNamePlaceholder: "Nome da atividade",
  activityDescPlaceholder: "Descrição da atividade",
  addActivity: "Adicionar",
  cancel: "Cancelar",
  activities: level1Activities,
  costCategories,
  costItems,
  costItemNotes,
  catalog: level1Catalog,
  validation: {
    summary: "Complete o resumo do projeto de carbono: {fields}.",
    data: "Complete os dados do projeto de carbono: {fields}.",
    costs: "Complete os custos do projeto de carbono: {fields}.",
    authenticationRequired: "Autenticação necessária. Conecte novamente sua carteira de desenvolvedor.",
    fields: {
      projectName: "nome do projeto",
      projectDescription: "descrição do projeto",
      projectType: "tipo de projeto",
      certifier: "certificador",
      methodology: "metodologia",
      fieldDataOption: "opção de dados de campo (parcelas ou sensoriamento remoto)",
      landOwnership: "posse da terra",
      projectBoundaryMap: "mapa do limite do projeto",
      projectArea: "área do projeto",
      currency: "moeda",
    },
  },

  // Step Chooser
  chooserTitle: "Escolha o caminho do projeto",
  chooserSubtitle: "Liste créditos emitidos ou crie um projeto para financiamento",
  chooserListCreditsTitle: "Créditos de carbono já emitidos",
  chooserListCreditsBtn: "Listar créditos",
  chooserNewProjectTitle: "Criar um projeto para financiamento",
  chooserNewProjectBtn: "Iniciar projeto",

  // List Credits form
  lcProjectLink: "Link do projeto",
  lcPddUpload: "Envie seu Documento de Concepção do Projeto",
  lcLocation: "Localização",
  lcLocationDesc: "Informe a localização do projeto ou envie um KML para detectar automaticamente",
  lcUploadKml: "Enviar KML/KMZ",
  lcBiome: "Bioma",
  lcState: "Estado",
  lcBoundary: "Limite do projeto (KML/KMZ)",
  lcPhotos: "Fotos",
  lcPhotosDesc: "Envie fotos do seu projeto",
  lcPhotosUploadTitle: "Enviar PNG ou JPG",
  lcPhotosSubLabel: "Somente PNG ou JPG",
  lcYearlyCreditSold: "Créditos vendidos por ano",
  lcYearlyCreditSoldDesc: "Registre os créditos vendidos por ano",
  lcPriceQuoteDesc: "Receba uma recomendação de preço para listar créditos emitidos e edite antes de enviar.",
  lcGetPriceRecommendation: "Obter recomendação de preço",
  lcPriceQuoteError: "A recomendação de preço falhou. Você ainda pode inserir um preço manualmente.",
  listingPrice: "Preço de listagem",
  lcListingPricePlaceholder: "12,50",

  // Success screen
  formSubmitted: "Formulário enviado",
  successMessage:
    "Obrigado pelo envio. Entraremos em contato o mais rápido possível.",
  seeHomepage: "Ver página inicial",

  // Tab labels
  tabs: {
    summary: "Resumo",
    data: "Dados",
    activities: "Atividades",
    timeline: "Cronograma",
    credits: "Créditos",
    costs: "Custos",
    price: "Preço",
    review: "Revisão",
  },

  // Step: Cronograma e emissão de créditos
  timeline: {
    scheduleBasicsTitle: "Cronograma do projeto",
    scheduleBasicsDesc:
      "Defina o calendário do projeto. Estes quatro números orientam a validação, o monitoramento, a geração de créditos e o cronograma de custos.",
    projectStartYear: "Ano de início do projeto",
    projectStartYearHint:
      "Validação, monitoramento e implementação começam.",
    creditingStartYear: "Primeiro ano de créditos",
    creditingStartYearHint: "Primeiro ano de geração de créditos.",
    modelingHorizonYears: "Anos a modelar",
    modelingHorizonYearsHint:
      "Horizonte de modelagem do investimento, limitado a 20 anos.",

    verificationScheduleTitle: "Cronograma de verificação e emissão",
    verificationScheduleDesc:
      "Escolha um preset compatível com a sua metodologia. Usuários avançados podem ajustar os valores derivados na seção avançada.",
    verificationPreset: "Preset de verificação e emissão",

    advancedAssumptions: "Premissas avançadas",
    advancedAssumptionsHint:
      "Sobreponha os valores inferidos a partir dos presets.",
    verificationCycleYears: "Ciclo de verificação (anos)",
    firstVerificationYear: "Primeiro ano de verificação",
    issuanceFrequency: "Frequência de emissão",
    firstIssuanceYear: "Primeiro ano de emissão",
    advancedDerivedNote:
      "Deixe qualquer campo em branco para manter o valor derivado do preset escolhido.",

    summaryTitle: "Pré-visualização do cronograma",
    summaryLine:
      "Primeira verificação em {firstVerification} • ciclo a cada {cycle} ano(s) • {issuance} • primeira emissão {firstIssuance}",

    presets: {
      standard_nature_based: "Padrão: verificar e emitir a cada 5 anos",
      faster_cycle: "Ciclo mais curto: verificar e emitir a cada 3 anos",
      annual_issuance: "Emissão anual",
      engineered_removal: "Remoção engenharia (anual)",
      gs_annual_reports_2y_first_verification:
        "Gold Standard: primeira verificação até o ano 2, depois até a cada 5 anos",
      car_forest_annual_reporting_full_every_6:
        "CAR floresta: relatórios anuais, verificação completa a cada 6 períodos",
      puro_engineered_annual_after_audit:
        "Puro engenharia: auditoria anual, emissão após cada auditoria",
      custom: "Personalizado (abrir campos avançados)",
    },
    presetDesc: {
      standard_nature_based:
        "Ciclo de verificação: 5 anos • Emissão: após cada verificação.",
      faster_cycle:
        "Ciclo de verificação: 3 anos • Emissão: após cada verificação.",
      annual_issuance: "Ciclo de verificação: 1 ano • Emissão: anual.",
      engineered_removal:
        "Ciclo de verificação: 1 ano • Emissão: anual. Indicado para DAC, BECCS, biochar.",
      gs_annual_reports_2y_first_verification:
        "Ciclo de verificação: 2 anos • Emissão: após cada verificação. Cadência Gold Standard.",
      car_forest_annual_reporting_full_every_6:
        "Ciclo de verificação: 6 anos • Emissão: após cada verificação. Cadência do CAR Mexico Forest Protocol.",
      puro_engineered_annual_after_audit:
        "Ciclo de verificação: 1 ano • Emissão: após cada auditoria. Conforme Puro General Rules 4.3.",
      custom: "Edite os valores derivados na seção avançada abaixo.",
    },

    freq: {
      after_verification: "Após verificação",
      annual: "Anual",
    },

    errors: {
      invalidShape: "Seção de cronograma ausente ou malformada.",
      invalidPreset: "Preset de verificação e emissão não reconhecido.",
      projectStartYearRange:
        "Ano de início do projeto deve estar entre {min} e {max}.",
      creditingStartYearRange:
        "Primeiro ano de créditos deve estar entre {min} e {max}.",
      modelingHorizonRange:
        "Anos a modelar deve estar entre {min} e {max}; a precificação do contrato suporta até {max} anos.",
      cycleRange: "Ciclo de verificação deve estar entre {min} e {max} anos.",
      creditingBeforeStart:
        "Primeiro ano de créditos não pode ser anterior ao ano de início do projeto.",
    },
  },
};
